import React, { useEffect, useState } from "react";
import { CheckCircle2, Info, AlertTriangle, X } from "lucide-react";

// Toasty v designu appky (17.7.2026) — náhrada za nativní alert().
// Použití odkudkoli: import { toast } from ".../components/Toast.jsx";
//   toast("Úkol založen.");                  → fialové info
//   toast("Hotovo!", "success");             → zelené
//   toast("Něco se nepovedlo.", "error");    → červené
// Host (<ToastHost/>) je namountovaný v Layoutu, komunikace přes CustomEvent.

export function toast(text, typ = "info") {
  try {
    window.dispatchEvent(new CustomEvent("fw40-toast", { detail: { text: String(text), typ } }));
  } catch { /* SSR/test prostředí */ }
}

const VZHLED = {
  info: { icon: Info, bar: "bg-brand-500", iconCls: "text-brand-600", bg: "bg-white" },
  success: { icon: CheckCircle2, bar: "bg-emerald-500", iconCls: "text-emerald-600", bg: "bg-white" },
  error: { icon: AlertTriangle, bar: "bg-rose-500", iconCls: "text-rose-600", bg: "bg-white" },
};

export default function ToastHost() {
  const [toasty, setToasty] = useState([]);

  useEffect(() => {
    let counter = 0;
    const h = (e) => {
      const id = `t${Date.now()}_${counter++}`;
      const { text, typ } = e.detail || {};
      setToasty((list) => [...list.slice(-3), { id, text, typ: VZHLED[typ] ? typ : "info" }]);
      // Chybové toasty drží déle, ať se stihnou přečíst.
      setTimeout(() => setToasty((list) => list.filter((t) => t.id !== id)), typ === "error" ? 7000 : 4500);
    };
    window.addEventListener("fw40-toast", h);
    return () => window.removeEventListener("fw40-toast", h);
  }, []);

  if (!toasty.length) return null;
  return (
    // 2.9.2026 (fáze 1 redesignu): na telefonu sedí toast NAHOŘE pod horní
    // lištou, ne dole. Dole od fáze 2 leží spodní lišta a toast ji překrýval,
    // takže po uložení nešlo přepnout sekci, dokud sám nezmizel. Na počítači
    // zůstává vpravo dole. z-[70] je vrstva toastů podle zadání: nad oknem (50)
    // i potvrzením (60), pod nápovědou (78) a celoobrazovkovým čekáním (80).
    <div className="pointer-events-none fixed inset-x-0 top-[calc(var(--admin-top,60px)+8px)] z-[70] mx-auto flex w-full max-w-md flex-col items-center gap-2 px-4 sm:inset-x-auto sm:bottom-4 sm:right-4 sm:top-auto sm:mx-0 sm:items-end">
      {toasty.map((t) => {
        const v = VZHLED[t.typ];
        const Icon = v.icon;
        return (
          <div key={t.id} className={`pointer-events-auto w-full ${v.bg} border border-slate-200 rounded-2xl shadow-2xl overflow-hidden flex items-stretch animate-[toastin_.25s_ease-out]`}>
            <div className={`w-1.5 shrink-0 ${v.bar}`} />
            <div className="flex items-center gap-2.5 px-3.5 py-3 flex-1 min-w-0">
              <Icon className={`w-5 h-5 shrink-0 ${v.iconCls}`} />
              <div className="text-sm text-slate-800 leading-snug">{t.text}</div>
            </div>
            <button onClick={() => setToasty((list) => list.filter((x) => x.id !== t.id))}
              className="px-2.5 text-slate-300 hover:text-slate-500 shrink-0" aria-label="Zavřít">
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
      {/* Na telefonu přilétá shora, na počítači zdola, ať to odpovídá tomu,
          kde se toast objeví. */}
      <style>{`@keyframes toastin { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
@media (min-width: 640px) and (min-height: 500px) { @keyframes toastin { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } } }`}</style>
    </div>
  );
}
